export default __webpack_public_path__ + "static/slider-2-0c86cbd56c8b6ccb8761abdf60bd39b4.webp";